import Splash from "../components/Splash";
import Home from "../components/Home/Home";
import Device from "../components/Home/Device";
import Configs from "../components/Home/Configs";
import Profile from "../components/Home/Profile";
import Agents from "../components/Profile/Agents";
import Contact from "../components/Profile/Contact";
import News from "../components/Profile/News";
import Guide from "../components/Profile/Guide";
import ManageUsers from "../components/Settings/ManageUsers";
import ManageCars from "../components/Settings/ManageCars";
import Login from "../components/Home/Login";
import Register from "../components/Home/Register";
import AdvancedConfigs from "../components/Home/AdvancedConfigs";
import Content from "../components/Profile/Content";
import NotifConfigs from "../components/Home/NotifConfigs";



const appRoutes = [
    {
        id : '0',
        path : '/',
        component : Splash
    },
    {
        id : '1',
        path : '/home',
        component : Home
    },
    {
        id : '1',
        path : '/device',
        component : Device
    },
    {
        id : '2',
        path : '/configs',
        component : Configs
    },
    {
        id : '3',
        path : '/profile',
        component : Profile
    },
    {
        id : '4',
        path : '/agents',
        component : Agents
    },
    {
        id : '5',
        path : '/contact',
        component : Contact
    },
    {
        id : '6',
        path : '/news',
        component : News
    },
    {
        id : '7',
        path : '/guide',
        component : Guide
    },
    {
        id : '8',
        path : '/manage-users',
        component : ManageUsers
    },
    {
        id : '9',
        path : '/manage-cars',
        component : ManageCars
    },
    {
        id : '10',
        path : '/login',
        component : Login
    },
    {
        id : '11',
        path : '/register',
        component : Register
    },
    {
        id : '12',
        path : '/advanced-setting',
        component : AdvancedConfigs
    },
    {
        id : '13',
        path : "/contents/:slug",
        component : Content
    },
    {
        id : '14',
        path : "/notifications-config",
        component : NotifConfigs
    },

];
export default appRoutes;